import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApplicantForm } from '../../forms/applicant.form';
import { ApplicantAppEntityApplicantWrite } from '../../../../../../../openapi';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-other-entity-form',
  standalone: true,
  imports: [
    CommonModule,
    NgxMaskDirective,
    ReactiveFormsModule,
    ValidationErrorsComponent
  ],
  templateUrl: './other-entity-form.component.html'
})
export class OtherEntityFormComponent implements OnInit {

  private applicantType = 'c6199647-b001-4d1f-a06e-9fbd7fb8cb39';

  @Input()
  public form: ApplicantForm | undefined;

  @Input()
  public showCancel: boolean = true;

  @Output()
  public onCancel = new EventEmitter();

  @Output()
  public onSubmit = new EventEmitter<ApplicantAppEntityApplicantWrite>();

  @Input()
  public edit = false;

  constructor() {
  }

  public submit(): void {
    if (this.form?.valid) {
      this.onSubmit.emit(this.form.toWriteModel());
      this.form.reset({ applicantType: this.applicantType });
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public cancel(): void {
    this.onCancel.emit();
    this.form?.reset({ applicantType: this.applicantType });
  }

  public ngOnInit(): void {
    this.form?.applicantType.setValue(this.applicantType);

    this.form?.name.enable();
    this.form?.nip.enable();
    this.form?.regon.enable();

    this.form?.firstName.disable();
    this.form?.lastName.disable();
  }

}
